/****************************************************
 * Module Name:  addRemarkMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import Constants from "../../utility/constants";
import logo from '../../images/pansuriya.jpg'
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import RemarkProxy from "../../utility/proxy/manager/manufacturingProxy/remarkProxy";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';

export default class AddRemarkMaster extends Component {
    constructor(props) {
        super(props);

        this.state = {
            newcategory: this.props.editOperation ? this.props.sourceData.category : "",
            newdescription: this.props.editOperation
                ? this.props.sourceData.description
                : "",

            showError: false,

            validateCategoryPresentSpinner: false,
            showValidationMessage: false,
            categoryAvailable: true,

            categoryValidationError: "",
            fullNameValidationError: "",
        };
    }

    handleSave = () => {
        let data = {
            id: this.props.editOperation ? this.props.sourceData.id : undefined,
            category: this.state.newcategory,
            description: this.state.newdescription,
        };

        if (this.props.handleSave) {
            if (this.props.handleValidation) {
                if (this.props.handleValidation(data)) this.props.handleSave(data);
                else
                    this.setState({
                        showError: true,
                    });
            } else this.props.handleSave(data);
        }
    };

    closeErrorDialog = () => {
        this.setState({
            showError: false,
        });
    };

    validateCategoryPresent = (categoryEntered) => {
        if (!categoryEntered || categoryEntered.trim() === "") return;

        this.setState({
            validateCategoryPresentSpinner: true,
        });

        RemarkProxy.CheckRemarkAvailable(categoryEntered, (response) => {
            //if we got response that means category is present at backend
            if (response) {
                //CategoryName already present
                this.setState({
                    validateCategoryPresentSpinner: false,
                    showValidationMessage: true,
                    categoryAvailable: false,
                });
            } else {
                //CategoryName not available, so can be used
                this.setState({
                    validateCategoryPresentSpinner: false,
                    showValidationMessage: true,
                    categoryAvailable: true,
                });
            }
        });
    };

    buttonDisable = () => {
        if (!this.props.editOperation)
            return !this.state.showValidationMessage || !this.state.categoryAvailable;

        return false;
    };

    render() {
        return (
            <Box>
                <CommonSnackbar
                    show={this.state.showError}
                    message={
                        <Box>
                            Add Remark Category validation Failed
                            <br /> Please enter complete data
                        </Box>
                    }
                    variant={"error"}
                    autoHide={false}
                    handleClose={this.closeErrorDialog}
                    title="Validation Failure"
                />

                <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;
                            {this.props.editOperation ? "Edit Remark Category" : "Add New Remark Category"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <center>
                            <table style={{ width: "100%" }}>
                                <tbody>
                                    {this.props.editOperation && (
                                        <tr>
                                            <td>
                                                <Form.Label>Remark Category Id</Form.Label>
                                            </td>
                                            <td>
                                                <Form.Label>{this.props.sourceData.id}</Form.Label>
                                            </td>
                                        </tr>
                                    )}
                                    {this.props.editOperation && (
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Remark Category <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        {this.props.editOperation ? (
                                            <td>
                                                <Form.Label>{this.state.newcategory}</Form.Label>
                                            </td>
                                        ) : (
                                            <td>
                                                <TextField
                                                    margin="normal"
                                                    fullWidth
                                                    size="small"
                                                    label="Category (required)"
                                                    placeholder="Enter Category"
                                                    value={this.state.newcategory}
                                                    autoFocus
                                                    onBlur={(e) =>
                                                        this.validateCategoryPresent(this.state.newcategory)
                                                    }
                                                    onChange={(e) =>
                                                        this.setState({
                                                            newcategory: e.target.value,
                                                            showValidationMessage: false,
                                                            categoryValidationError: Utility.CheckIsPresent(
                                                                e.target.value
                                                            )
                                                                ? ""
                                                                : "Category Cannot be Empty",
                                                        })
                                                    }
                                                    helperText={this.state.categoryValidationError}
                                                    error={this.state.categoryValidationError.length > 0}
                                                />
                                            </td>
                                        )}
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>
                                            {this.state.validateCategoryPresentSpinner ? (
                                                <CircularProgress size="1rem" />
                                            ) : !this.state.showValidationMessage ? (
                                                <Box>&nbsp;</Box>
                                            ) : this.state.categoryAvailable ? (
                                                <font color="green">Category available</font>
                                            ) : (
                                                <font color="red">Category not available</font>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>Description</Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                size="small"
                                                label="Description"
                                                placeholder="Enter Description"
                                                value={this.state.newdescription}
                                                onChange={(e) =>
                                                    this.setState({ newdescription: e.target.value })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                </tbody>
                            </table>
                        </center>
                    </Modal.Body>
                    <Modal.Footer>
                        <LoadingButton
                            loading={this.props.loading}
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            variant="contained"
                            onClick={() => this.handleSave()}
                            disabled={this.buttonDisable()}
                            sx={{ mr: 1 }}
                        >
                            Save
                        </LoadingButton>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={this.props.handleClose}
                            disabled={this.props.loading}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Box>
        );
    }
}
